import { useEffect, useCallback, useState, useContext, createContext } from 'react'
import { useAuth } from '../../../../../../context/AuthContext'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { api } from '../../../../../../services/api'
import moment from 'moment'

export const GroupsDetailedContext = createContext();


export function GroupsDetailedProvider({ children }){
    const groupsDatas = useSelector(state => state.modalCentralized.datasComponent)
    const { signOut } = useAuth()
    const [isLoading, setIsLoading] = useState(true)
    const [allGroupsDatas, setAllGroupsDatas] = useState({})
   
    let dateToDownload = `Grupos: ${moment(groupsDatas.startDate).format('DD/MM/YYYY HH:mm')} até ${moment(groupsDatas.endDate).format('DD/MM/YYYY HH:mm')}`
    
    const fetchData = useCallback(async () => {
        setIsLoading(true)
       
        try{
            await api.post('/getResumeGroups' , groupsDatas, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => {
                setAllGroupsDatas(response.data)
            })
            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [signOut, groupsDatas])

    

    useEffect(() => {

        fetchData()

    }, [fetchData])


    return(
        <GroupsDetailedContext.Provider 
            value={ { 
                isLoading,
                allGroupsDatas,
                dateToDownload,
                groupsDatas,
            } }
        >
            { children }
        </GroupsDetailedContext.Provider>
    )
    }



export function useGroupsDetailed() {
   const context = useContext(GroupsDetailedContext)

   if(!context) {
    throw new Error('useGroupsDetailed must be used within an Provider');
  } 

   return context
}
